import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { GlobalService } from '@modules/core/services';

import { selectCompanyUuid } from '@public-page/store/company';
import { GlobalErrorActions } from './global-error.actions';

@Injectable()
export class GlobalErrorEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private router: Router,
    private globalService: GlobalService
  ) {}

  redirectToErrorPage$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(GlobalErrorActions.handleError),
        concatLatestFrom(() => [this.store.select(selectCompanyUuid)]),
        tap(([{ error }, companyUuid]) => {
          const path = this.globalService.hasCustomDomain
            ? ['error', error.status]
            : [companyUuid, 'error', error.status];

          this.router.navigate(path);
        })
      );
    },
    { dispatch: false }
  );
}
